import { NavigationGuard } from "vue-router";

export const isPageId = (id: string | undefined): boolean =>
  id?.startsWith("page") || false;
export const isEventId = (id: string | undefined): boolean =>
  id?.startsWith("event") || false;

// export const updatePerson: NavigationGuard = (to, from, next) => {
//   const { controller } = globalThis;
//   const id = to.params.id;
//   if (controller && id) {
//     const people_id = typeof id === "string" ? id : id[0];
//     if (people_id) controller.loadPeople(people_id);
//   }
//   next();
// };

export const updatePerson: NavigationGuard = (to, _from, next) => {
  const { controller } = globalThis;
  const param = to.params.id;
  const id = Array.isArray(param) ? param[0] : param;
  if (controller && id) {
    controller.people.refresh(id);
  }
  next();
};
